import { api } from 'app/config/apiConfig';
import { Pagination } from 'app/types/common';
import { Box } from '../model/types';
import { InvoiceFrequencyType } from 'entities/Invoice';
import { UnitType } from 'entities/Contract';

interface Params {
  sizeCodeId?: string;
  warehouseId?: string;
  page?: number;
  limit?: number;
  isAvailable?: boolean;
  priceFactor?: number;
  priceFrom?: number;
  priceTo?: number;
  priceRateType?: InvoiceFrequencyType;
  floorId?: Nullable<string>;
  orderBy?: string;
  unitType?: UnitType;
}

export const getAvailableOfficesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getOfficesForBooking: build.query<Pagination<Box>, Params>({
      query: (args) => ({
        url: `/boxes/booking?unitType=${UnitType.OFFICE}`,
        params: { ...args },
      }),
      providesTags: ['Available offices'],
    }),
  }),
});

export const { useGetOfficesForBookingQuery } = getAvailableOfficesApi;
